"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBackClick = exports.handleClearClick = exports.updateLocation = exports.locationClick = exports.handleLocationInput = exports.handleLocationChange = exports.handleFilterClick = exports.handleResize = exports.handleInput = exports.priceConfig = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _helpers = require("../../helpers");

var priceConfig = {
  name: 'Sort Price',
  options: [{
    id: 1,
    value: 'Relevance'
  }, {
    id: 2,
    value: 'Price: Low to High'
  }, {
    id: 3,
    value: 'Price: High to Low'
  }]
};
exports.priceConfig = priceConfig;

var handleInput = function handleInput(e, setSubmitQuery) {
  e.preventDefault();
  if (e.keyCode === 13) setSubmitQuery(true);
  setSubmitQuery(false);
};

exports.handleInput = handleInput;

var handleResize = function handleResize(e, _ref) {
  var setMaxItems = _ref.setMaxItems;
  var itemsLength = (0, _helpers.windowBreakPoints)();
  setMaxItems(itemsLength);
};

exports.handleResize = handleResize;

var handleFilterClick = function handleFilterClick(e, _ref2) {
  var choice = _ref2.choice,
      query = _ref2.query,
      setQuery = _ref2.setQuery,
      setSearchTerm = _ref2.setSearchTerm;

  if (!e.target.className.includes('availability')) {
    setQuery({
      term: choice,
      zip: query.zip
    });
    setSearchTerm('clear');
    window.history.pushState(null, null, "".concat(window.location.origin).concat(window.location.pathname, "?term=").concat(choice));
  }
};

exports.handleFilterClick = handleFilterClick;

var handleLocationChange = function handleLocationChange(value, setLocation) {
  var val = value.replace(/\D/g, '');
  if (val.length <= 5) setLocation(val);
};

exports.handleLocationChange = handleLocationChange;

var handleLocationInput = function handleLocationInput(e, _ref3) {
  var setQuery = _ref3.setQuery,
      query = _ref3.query;
  e.preventDefault();
  var zip = e.target.value === '' ? null : e.target.value;
  if (e.keyCode == 13) setQuery({
    term: query.term,
    zip: zip
  });
};

exports.handleLocationInput = handleLocationInput;

var locationClick = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e, state) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _helpers.getLocation)(state);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function locationClick(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.locationClick = locationClick;

var updateLocation = function updateLocation(_ref5) {
  var setToggle = _ref5.setToggle,
      setNewLocation = _ref5.setNewLocation,
      toggle = _ref5.toggle,
      supplier = _ref5.supplier,
      location = _ref5.location;
  setToggle(!toggle);
  setNewLocation({
    supplier: supplier,
    location: location
  });
};

exports.updateLocation = updateLocation;

var handleClearClick = function handleClearClick(_ref6) {
  var setQuery = _ref6.setQuery,
      query = _ref6.query,
      setSearchTerm = _ref6.setSearchTerm,
      setPriceFilter = _ref6.setPriceFilter,
      priceConfig = _ref6.priceConfig,
      curCat = _ref6.curCat;
  setPriceFilter(priceConfig.options[0]);
  setSearchTerm('clear');
  var subFilters = [];
  curCat.subFilters.forEach(function (sub, i) {
    if (sub.required) {
      subFilters[i] = query.subFilters[i];
    } else {
      subFilters[i] = undefined;
    }
  });
  if (curCat.multiSelect) subFilters = [undefined];
  setQuery({
    term: query.term,
    zip: query.zip,
    subFilters: subFilters
  });
};

exports.handleClearClick = handleClearClick;

var handleBackClick = function handleBackClick(_ref7) {
  var onBackClick = _ref7.onBackClick,
      router = _ref7.router,
      config = _ref7.config;
  router.history.push({
    pathname: "/stores/".concat(config.url)
  });
  onBackClick();
};

exports.handleBackClick = handleBackClick;